import React, { useEffect, useRef } from "react";
import { useBlade } from "../../../services/BladeProvider";

interface Props {
  text: string;
  onClick: (id: number) => void;
  id: number;
  isadding: boolean;
}

const MobileResultTab = ({ onClick, text, id,isadding }: Props) => {
  const tabRef = useRef<HTMLDivElement>(null); // Create a ref for the div

  const { getFocusedBlade, setFocusedBlade } = useBlade();
  const clickedOnBlade = (id:number) => {
    if (isadding){
      onClick(-1);
      return;
    }
    else if (id < -1)
    {
      return;
    }
    setFocusedBlade(id);
  }
  useEffect(() => {
    
    if (getFocusedBlade(id) && tabRef.current) {
      tabRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, [getFocusedBlade, id]); // Depend on getFocusedBlade and id

  return (
    <div
    ref={tabRef} 
      style={{ background: getFocusedBlade(id) ? "" : "#677275" }}
      className="mobile-tab"
      onClick={() => clickedOnBlade(id)}
    >
      <span className={"mobile-tab-text " + (isadding ? "mobile-tab-active" : "")}  >{text}</span>
    </div>
  );
};

export default MobileResultTab;
